/// <reference path="../../ng-services/chat.service.ts"/>

import { Meeting } from '../../models/chat';
import { ChatAttachmentUploadService } from '../../ng-services/chat-attachment-upload.service';
import { ChatMessageInputStore } from '../../ng-services/chat-message-input.store';
import { ChatMessageSenderService } from '../../ng-services/chat-message-sender.service';

(function () {
    class MessageInputToolbarComponent {
        static $inject = [
            '$element',
            'ChatMessageInputStore',
            'ChatMessageSenderService',
            'ChatAttachmentUploadService',
        ];

        public conversation!: Meeting;

        constructor(
            private $element: ng.IRootElementService,
            private chatMessageInputStore: ChatMessageInputStore,
            private messageSender: ChatMessageSenderService,
            private attachmentUploadService: ChatAttachmentUploadService
        ) {}

        $onInit() {
            const input = this.$element.find('#attachment-upload')[0] as HTMLInputElement;

            input.addEventListener(
                'change',
                () => {
                    Array.from(input.files || []).forEach((file) => this.upload(file));
                    input.value = '';
                },
                false
            );
        }

        sendMessage() {
            this.messageSender.publish(this.conversation.id);
            this.chatMessageInputStore.dispatchUpdateInputState(this.conversation.id, {
                content: '',
                quoted_message: undefined,
                editedMessage: undefined,
                uploads: [],
            });
        }

        protected upload(file: File) {
            this.attachmentUploadService.upload(this.conversation, file);
        }
    }

    angular.module('tradersyard').component('tyMessageInputToolbar', {
        template: `
<div class="message_input_toolbar" is-uib>
<label class="message_input_toolbar__file_upload" uib-tooltip="Attach file">
    <i class="fa fa-paperclip"></i>
    <input type="file" id="attachment-upload" multiple/>
</label>
<a href="#" ng-click="$ctrl.sendMessage()" uib-tooltip="Send message"><i class="fa fa-paper-plane"></i></a>
</div>
        `,
        controller: MessageInputToolbarComponent,
        bindings: {
            conversation: '<',
        },
    });
})();
